export enum AgeRange {
    birthDate_less_than_18 = 'birthDate_less_than_18',
    birthDate_18_to_49 = 'birthDate_18_to_49',
    birthDate_50_to_54 = 'birthDate_50_to_54',
    birthDate_55_to_59 = 'birthDate_55_to_59',
    birthDate_60_to_64 = 'birthDate_60_to_64',
    birthDate_over_65 = 'birthDate_over_65'
}
